import { Spin } from "antd";
import moment from "moment";
import { MdDelete } from "react-icons/md";
import { NavLink } from "react-router-dom";
import { useEffect, useState } from "react";
import { IoIosWarning } from "react-icons/io";
import ReactS3Client from "react-aws-s3-typescript";
import { FileUploader } from "react-drag-drop-files";
import { useForm, SubmitHandler } from "react-hook-form";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import ReactQuill from "react-quill";

import Breadcrumb from "Components/Breadcrums";
import FormControl from "Components/FormControl";
import Imagepreview from "Components/ImagePreview";
import Upload from "Components/UploadDesign/upload";
import { showErrorAlert, showWarningAlert, Toast } from "Util/Alerts";

import { config } from "../../../s3config";
import { breadcrumbItems, formFields } from "./Constant";
import { ProductsTypeInputs, image, sizesType } from "./Types";
import {
    update_Products,
    add_Products,
    Get_category,
    uploadMutipleImage,
} from "Services/Requests";
import Styles from "Styles/Styles.module.css";
import { categoryType } from "Pages/Auth/Category/Types";

import { v4 as uuidv4 } from "uuid";

window.Buffer = window.Buffer || require("buffer").Buffer;

function AddPromocode() {
    const navigate = useNavigate();
    const fileTypes = ["JPG", "PNG", "JPEG"];
    const { type } = useParams();
    const location = useLocation();
    const [loading, setLoading] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
    const [category, setcategory] = useState([{ label: "", value: "" }]);
    const [quillData, setQuillData] = useState("");

    const [Sizes, setSizes] = useState<sizesType[]>([
        { size: "", stock: "", err: "", id: uuidv4() },
    ]);
    const [PromocodeImg, setPromocodeImg] = useState<image[]>([]);
    const [selectedImage, setSelectedImage] = useState("");
    const [ErrorMsg, setErrorMsg] = useState<null | string>(null);

    const {
        register,
        handleSubmit,
        formState: { errors },
        setValue,
        reset,
        watch,
        setError,
    } = useForm<ProductsTypeInputs>();

    const handleChange = (files: any) => {
        setErrorMsg("");
        const formData = new FormData();
        formData.append("folder", "product_images");
        for (let i = 0; i < files.length; i++) {
            formData.append("images", files[i]);
        }
        uploadMutipleImage(formData)
            .then((res: any) => {
                // setValue("product_image", );

                let previewData: image[] = [];
                for (let i = 0; i < files.length; i++) {
                    previewData.push({
                        id: uuidv4(),
                        location: res?.data?.images[i],
                        url: res?.data?.urls[i],
                    });
                }
                setPromocodeImg((prev) => [...prev, ...previewData]);
                setLoading(false);
            })
            .catch((err: any) => {
                alert(err);
                setLoading(false);
            });
    };
    function validateAndSubmit(allData: sizesType[]): void {}

    const onSubmit: SubmitHandler<ProductsTypeInputs> = async (data) => {
        if (PromocodeImg.length == 0) {
            setErrorMsg("Please Upload File");
            return;
        }
        if (quillData === "") {
            setErrorMsg("Description is required");
            return;
        }
        if (data?.has_sizes) {
            let hasError = false;
            let array = Sizes;
            // Loop through the array to check for errors
            array.forEach((item) => {
                if (!item.size || !item.stock) {
                    item.err = "Both size and stock are required.";
                    hasError = true; // Set the flag to true if there's an error
                } else {
                    item.err = ""; // Clear any previous errors if the fields are valid
                }
            });

            if (hasError) {
                setSizes(array);
                return;
            }
        }
        try {
            setLoading(true);
            let response;
            if (type === "edit") {
                response = await update_Products(location.state?.product_id, {
                    ...data,
                    product_image: PromocodeImg.map((item) => item.location),
                    has_sizes: data?.has_sizes ? 1 : 0,
                    is_coming_soon: data?.is_coming_soon ? 1 : 0,
                    product_description: quillData,
                    sizes: data.has_sizes
                        ? Sizes.map((item) => ({
                              size: item.size,
                              stock: item.stock,
                          }))
                        : [],
                });
            } else {
                response = await add_Products({
                    ...data,
                    product_image: PromocodeImg.map((item) => item.location),
                    has_sizes: data?.has_sizes ? 1 : 0,
                    product_description: quillData,
                    is_coming_soon: data?.is_coming_soon ? 1 : 0,
                    sizes: data.has_sizes
                        ? Sizes.map((item) => ({
                              size: item.size,
                              stock: item.stock,
                          }))
                        : [],
                });
            }
            if (response?.data?.status === 1) {
                Toast(response?.data?.Message, "success");
                navigate(-1);
            } else {
                showWarningAlert(response?.data?.Message);
            }
        } catch (err: any) {
            showErrorAlert(
                err?.response?.data?.Message ||
                    err?.response?.data?.message ||
                    "Something went wrong, try again later"
            );
        } finally {
            setLoading(false);
        }
    };

    const watchData = watch();

    const fetchDropDowns = async () => {
        try {
            const [CategoryData] = await Promise.all([Get_category()]);
            if (CategoryData.data.status == 1) {
                console.log(CategoryData?.data?.categories);
                setcategory(
                    CategoryData?.data?.categories?.map(
                        (item: categoryType) => ({
                            label: item.category_name,
                            value: item.category_id,
                        })
                    )
                );
                if (type === "edit") {
                    let formData = location.state;
                    setSizes(
                        formData?.has_sizes == 1 && formData?.sizes
                            ? formData?.sizes?.map((item: sizesType) => ({
                                  err: "",
                                  size: item.size,
                                  stock: item.stock,
                                  id: uuidv4(),
                              }))
                            : [{ err: "", size: "", id: "", stock: "" }]
                    );
                    formData = {
                        ...formData,
                    };
                    if (location?.state?.product_image?.length > 0) {
                        let preview = location?.state?.product_image?.map(
                            (item: any) => {
                                let s = String(item).split("/");
                                // console.log();
                                return {
                                    id: uuidv4(),
                                    location: s[s.length - 1],
                                    url: item,
                                };
                            }
                        );
                        setPromocodeImg(preview);
                    }

                    reset({
                        ...formData,
                        startDate: moment(formData.startDate).format(
                            "YYYY-MM-DD"
                        ),
                        available_date: moment(formData.available_date).format(
                            "YYYY-MM-DD"
                        ),
                        is_coming_soon:
                            formData?.is_coming_soon == 1 ? true : false,
                        has_sizes: formData?.has_sizes == 1 ? true : false,
                        endDate: moment(formData.endDate).format("YYYY-MM-DD"),
                    });
                    setQuillData(formData.product_description);

                    /*    setPromocodeImg(
                        location.state?.product_image.map((item: string) => ({
                            id: uuidv4(),
                            location: `${String(item).split("/")[1]}`,
                            url: item,
                        }))
                    ); */
                }
            }
        } catch (err) {
            console.log(err);
        }
    };
    console.log(PromocodeImg);

    useEffect(() => {
        fetchDropDowns();
    }, [type, location.state, reset]);
    const changeHandler = (
        value: string | number,
        key: string,
        id: number | string
    ) => {
        setSizes((prev) =>
            prev.map((item) =>
                item.id != id ? item : { ...item, [key]: value }
            )
        );
    };
    const toolbarOptions = [
        [{ font: [] }], // Font family
        [{ size: [] }], // Font size
        ["bold", "italic", "underline", "strike"], // Text formatting
        [{ align: [] }], // Alignment
        [{ list: "ordered" }, { list: "bullet" }], // Lists

        [{ color: [] }, { background: [] }], // Text color and background color
    ];
    const modules = {
        toolbar: {
            container: toolbarOptions,
            handlers: {
                // Custom handlers if needed
            },
        },
    };
    return (
        <div className={Styles["Add_form_wrapper"]}>
            <Imagepreview
                handleCancel={() => setIsModalVisible(false)}
                selectedImage={selectedImage}
                isModalVisible={isModalVisible}
                title="Products"
            />
            <h3>
                <span style={{ textTransform: "capitalize" }}>{type}</span>{" "}
                Products
            </h3>
            <Breadcrumb items={breadcrumbItems} type={type} />
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className={Styles["form"]}>
                    <h4>Product</h4>
                    <div className={Styles["form_control"]}>
                        <label htmlFor="Photo">Photo</label>
                        <FileUploader
                            handleChange={handleChange}
                            name="file"
                            types={fileTypes}
                            children={Upload}
                            multiple={true}
                        />
                        <span style={{ fontSize: "0.9rem" }}>
                            Upload an image with dimensions of 430x390.
                        </span>
                        {PromocodeImg.length > 0 && (
                            <div className={Styles["multiImage"]}>
                                {PromocodeImg?.map((item) => (
                                    <div className={Styles["remove_upload"]}>
                                        <div
                                            onClick={() => {
                                                setIsModalVisible(true);
                                                setSelectedImage(item.url);
                                            }}>
                                            <img
                                                src={item.url}
                                                alt="Promocode"
                                            />
                                        </div>
                                        <button
                                            onClick={() => {
                                                setPromocodeImg((prev) =>
                                                    prev.filter(
                                                        (previmg) =>
                                                            previmg.id !=
                                                            item.id
                                                    )
                                                );
                                            }}>
                                            <MdDelete />
                                        </button>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                    <FormControl
                        label={"Name"}
                        name={"product_name"}
                        register={register}
                        errors={errors["product_name"]}
                        requiredMessage={"Product Name is required"}
                        type={"text"}
                    />
                    <FormControl
                        label={"Category"}
                        name={"category_id"}
                        register={register}
                        errors={errors["category_id"]}
                        requiredMessage={"Category is required"}
                        type={"select"}
                        options={category}
                    />
                    {formFields.map((field) => (
                        <FormControl
                            key={field.name}
                            label={field.label}
                            name={field.name}
                            register={register}
                            errors={errors[field.name]}
                            requiredMessage={field.required}
                            type={field.type}
                            options={field.options || []}
                            validate={field?.validate}
                        />
                    ))}{" "}
                    <div
                        className={`${Styles["form_control_quill"]} quill_custom`}
                        style={{ gridColumn: "1/-1" }}>
                        <label htmlFor="Banner Name">Description *</label>
                        <ReactQuill
                            theme="snow"
                            value={quillData}
                            onChange={setQuillData}
                            modules={modules}
                            // theme="snow" // Use 'snow' theme
                        />
                    </div>
                    {watchData.has_sizes && (
                        <fieldset className={Styles["product_fieldset"]}>
                            <legend>
                                Sizes{" "}
                                <button
                                    onClick={() =>
                                        setSizes((prev) => [
                                            ...prev,
                                            {
                                                id: uuidv4(),
                                                err: "",
                                                size: "",
                                                stock: "",
                                            },
                                        ])
                                    }
                                    className={Styles["add_btn"]}
                                    type="button">
                                    Add
                                </button>
                            </legend>
                            <div className={Styles["product_size_wrapper"]}>
                                {Sizes?.map((item, index) => (
                                    <div
                                        className={
                                            Styles["product_size_input_wrap"]
                                        }>
                                        <div className={Styles["form_control"]}>
                                            <label htmlFor="">
                                                Size{" "}
                                                <span style={{ color: "red" }}>
                                                    *
                                                </span>
                                            </label>
                                            <input
                                                type="text"
                                                value={item.size}
                                                onChange={(e) =>
                                                    changeHandler(
                                                        e.target.value,
                                                        "size",
                                                        item.id
                                                    )
                                                }
                                            />
                                            {item.err.length > 0 && (
                                                <p
                                                    className={
                                                        Styles["Gen-erro_msg"]
                                                    }>
                                                    {" "}
                                                    {item.err}{" "}
                                                    <span
                                                        style={{
                                                            color: "red",
                                                        }}>
                                                        *
                                                    </span>
                                                </p>
                                            )}
                                        </div>
                                        <div className={Styles["form_control"]}>
                                            <label htmlFor="">
                                                Stock{" "}
                                                <span style={{ color: "red" }}>
                                                    *
                                                </span>
                                            </label>
                                            <input
                                                onChange={(e) =>
                                                    changeHandler(
                                                        Number(e.target.value),
                                                        "stock",
                                                        item.id
                                                    )
                                                }
                                                type="number"
                                                value={item.stock}
                                            />
                                        </div>

                                        <button
                                            type="button"
                                            onClick={() => {
                                                setSizes((prev) =>
                                                    prev.filter(
                                                        (previmg) =>
                                                            previmg.id !=
                                                            item.id
                                                    )
                                                );
                                            }}>
                                            <MdDelete color="white" size={22} />{" "}
                                            Delete
                                        </button>
                                    </div>
                                ))}
                            </div>
                        </fieldset>
                    )}
                    <div className={Styles["form_control_check_box"]}>
                        <input
                            type="checkbox"
                            {...register("has_sizes")}
                            id="size"
                            defaultChecked={watchData?.has_sizes}
                        />
                        <label htmlFor="size">Has sizes?</label>
                    </div>
                    <div className={Styles["form_control_check_box"]}>
                        <input
                            type="checkbox"
                            {...register("is_coming_soon")}
                            id="sooon"
                            defaultChecked={watchData?.is_coming_soon}
                        />
                        <label htmlFor="sooon">Comming soon?</label>
                    </div>
                    {type == "edit" && (
                        <FormControl
                            key={"status"}
                            label={"Status"}
                            name={"status"}
                            register={register}
                            errors={errors["status"]}
                            requiredMessage={"this field is required"}
                            type={"select"}
                            options={[
                                { value: 1, label: "Active" },
                                { value: 0, label: "Inactive" },
                            ]}
                        />
                    )}
                    {watchData.is_coming_soon && (
                        <FormControl
                            key={"available_date"}
                            label={"Available Date"}
                            name={"available_date"}
                            register={register}
                            errors={errors["available_date"]}
                            requiredMessage={"this field is required"}
                            type={"date"}
                        />
                    )}
                    {ErrorMsg && (
                        <p className={Styles["Gen-erro_msg"]}>
                            <IoIosWarning /> {ErrorMsg}
                        </p>
                    )}
                </div>

                {loading ? (
                    <Spin size="default" />
                ) : (
                    <button>{type === "edit" ? "Update" : "Add"}</button>
                )}
            </form>
        </div>
    );
}

export default AddPromocode;
